import { SVG, getDefaultHeight } from '@ui/kit/icons';
import { jsx } from 'react/jsx-runtime';

const ArrowToFacitIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 45.522 18.755",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 18.755),
    ...svgProps,
    fill: color ?? svgProps.fill ?? "currentColor",
    children: /*#__PURE__*/jsx("path", {
      d: "m45.522.04-20.435 18a2.999 2.999 0 0 1-3.888 0L.764.65C.04.032.34 0 0 0Z"
    })
  });
};

export { ArrowToFacitIcon };
//# sourceMappingURL=icon.arrow-to-facit.js.map
